/**
 * Shareable company link kinds surfaced in the Active links grid.
 *
 * The values match the `linkType` string the JobApplicants API returns, so a row coming
 * straight off that endpoint needs no translation. Onboarding links predate the field and
 * come from CompanyOnboarding, which returns no type at all — the mapper stamps it.
 */
export enum LinkType {
  Onboarding = 'Onboarding',
  Application = 'Application',
}
